<template>
    <hts-modal
        :show="visible"
        :title="$t('labels.createInvoice')"
        type="confirm"
        content=""
        @close="close"
        @confirm="handleCreateInvoice" />
</template>
<script lang="ts" setup>
const visible = ref<boolean>(false)
const emits = defineEmits(['refreshTables'])
const tripId = ref('')
const debitId = ref('')

const open = (tId: string, dId: string) => {
  tripId.value = tId
  debitId.value = dId
  visible.value = true
}

const close = () => {
  visible.value = false
}

const handleCreateInvoice = async () => {
  const api = {
    url: '/trip/tripId/billing-and-costing/invoice',
    method: 'post'
  }

  const data: any = await $api(api, {
    uriParams: { tripId: tripId.value },
    body: {
      debitId: debitId.value
    }
  })

  const resData = data?.data?.value

  if (resData && resData.success) {
    if (resData.success) {
      process.client && $toast().success($t('labels.addSuccess'))
      close()
      emits('refreshTables')
    } else {
      // Freightek errors
    }
  }
}

defineExpose({
  open,
  close
})
</script>
